export default __webpack_public_path__ + "static/media/portfolio-simple-2-p1.47f04973.jpg";